import { render, staticRenderFns } from "./EditShipmentNumberField.vue?vue&type=template&id=2702fc8d"
import script from "./EditShipmentNumberField.vue?vue&type=script&lang=js"
export * from "./EditShipmentNumberField.vue?vue&type=script&lang=js"
import style0 from "./EditShipmentNumberField.vue?vue&type=style&index=0&id=2702fc8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports